import './styles/HomePage.scss';

import { useApolloClient } from '@apollo/client';
import { Grid, useMediaQuery } from '@mui/material';

import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import USER_QUERY from 'gql/queries/currentUser.gql';

import { ErrorBoundary } from 'app/components';
import { TileDrawer } from 'app/components/TileDrawer';
import { translations } from 'locales/i18n';
import { ACLHelper } from 'utils/ACLHelper';
import usePageHeading from 'utils/hooks/usePageHeading';

import { ArticlesList } from '../../Articles/ArticlesList';
import { CalendarCard } from './components/CalendarCard';
import { DashboardContent } from './components/DashboardContent';
import { WatchlistCard } from './components/Watchlist/WatchlistCard';

export enum TileType {
  SYSTEM = 'SYSTEM',
  DEFAULT = 'DEFAULT',
  CUSTOM = 'CUSTOM'
}

export enum StyleType {
  JOBMARKET = 'JOBMARKET'
}

export function HomePage() {
  const { t } = useTranslation();

  const calendarBreakpointMd = useMediaQuery('(min-width:1080px)');
  const calendarBreakpointMd2 = useMediaQuery('(min-width:1400px)');

  const client = useApolloClient();
  const userData = client.readQuery({ query: USER_QUERY });
  usePageHeading(t(translations.layout.menu.dashboard()));

  const aclHelper = new ACLHelper(userData.currentUser);

  /*
   * Render Dashboard
   */
  return (
    <>
      <TileDrawer createType={TileType.CUSTOM} />
      <Helmet>
        <title>{t(translations.pages.home.title())}</title>
      </Helmet>
      <Grid container className="homepage-container" spacing={2}>
        <Grid item xs={12} md={calendarBreakpointMd ? 9 : calendarBreakpointMd2 ? 8 : 7} sm={7}>
          <DashboardContent />
        </Grid>
        <Grid item xs={12} md={calendarBreakpointMd ? 3 : calendarBreakpointMd2 ? 4 : 5} sm={5}>
          <Grid item>
            <WatchlistCard />
          </Grid>
          {!aclHelper.isCompanyUser() && !aclHelper.isInternationalOfficeUser() && (
            <>
              <Grid item>
                <ArticlesList
                  condensed
                  heading={t(translations.pages.home.articlesList.today())}
                  scope="today"
                />
              </Grid>
              <Grid item>
                <ErrorBoundary boundaryTag="calendarCard">
                  <CalendarCard />
                </ErrorBoundary>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
}
